import Cookies from 'universal-cookie'
const cookies = new Cookies()
var cookieConfig = {}
export function saveCookie (name, value) {
  cookies.set(name, value, cookieConfig)
}

export function getCookie (name) {
  return cookies.get(name)
}

export function removeCookie (name) {
  cookies.remove(name, cookieConfig)
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js